/* External dependencies */
import React from 'react';
import get from 'lodash/get';

/* Internal dependencies */
import MediaObject, { DEFAULT_IMAGE_SIZE, Props as MediaObjectProps } from '../mediaObject/MediaObject';
import ProfileImage from 'src/profiles/ProfileImage';
import Verified from 'src/verified/Verified';

type OwnProps = {
  artist: any;
  right?: React.ReactNode;
} & Partial<MediaObjectProps>;

type Props = OwnProps;

const Artist: React.FunctionComponent<Props> = ({ artist, right, imageSize = DEFAULT_IMAGE_SIZE, textColor, ...rest }) => {
  return (
    <MediaObject
      {...rest}
      text={(
        <div className="d-flex align-items-center">
          <span className={`${textColor === 'light' ? 'text-light' : 'text-dark'}`}>{get(artist, 'name')}</span>
          <div className="pb-1">
            <Verified
              profile={artist}
              size={16}
            />
          </div>
        </div>
      )}
      imageType="circle"
      image={(
        <ProfileImage
          profile={artist}
          imageSize={imageSize as number}
        />
      )}
      right={right}
      textColor={textColor}
      />
    );
};

export default Artist;
